import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import SyncWithUs from "./sections/SyncWithUs";
import OurGlobalKitchen from "./sections/OurGlobalKitchen";
import FaqSection from "./sections/FaqSection";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <SyncWithUs />
      <OurGlobalKitchen />
      <FaqSection />
      <Footer />
    </div>;
}